import { t } from '../translate';
import { ConnectionApiError } from './apiError';
/**
 * Assert that the HttpService is configured. Will throw an error if not.
 * @internal
 */
export function assertHttpServiceConfigured(httpService) {
    if (!httpService) {
        throw new Error('HttpService not configured');
    }
}
/**
 * Handle non-ok status codes on connections api.
 * Will throw an error if the response is not ok.
 * @internal
 */
export function handleBadResponse(response) {
    if (response.status == 403) {
        throw new Error(t('connections.error403'));
    }
    if (response.status == 404) {
        throw new ConnectionApiError('Connection not found');
    }
    if (response.status == 409) {
        throw new ConnectionApiError('Connection already exists');
    }
    if (!response.ok) {
        console.error('Connection API error', response);
        throw new Error(t('connections.apiError'));
    }
}
/**
 * Handle duplicate connection name.
 * Will throw an error if the connection name already exists.
 * @internal
 */
export function handleDuplicateConnectionName(connections, connection) {
    if (connections.some(({ Name }) => Name.toLowerCase() == connection.Name.toLowerCase())) {
        throw new ConnectionApiError('Connection name already exists');
    }
}
/**
 * Handle existing primary connection.
 * @internal
 */
export async function handleExistingPrimaryConnection(response) {
    if (response.status != 409) {
        return;
    }
    const data = (await response.json());
    throw new ConnectionApiError('Another project uses this connection as primary', { contextId: data.contextId });
}
